import React from 'react';
import { Stopwatch, Speedometer2 } from 'react-bootstrap-icons';
import CareMapprPopup from '../../Popup/CareMapprPopup';
import { ChipBackgroundColor, ChipLabelColor } from '../../Chip/types';
import Chip from '../../Chip/Chip';

import EventTriggers from '../../ProfileBar/components/EventTriggers';
import PrioritisationFeedbackButton from './PrioritisationFeedback/PrioritisationFeedbackButton';
import PrioritisationFeedback from './PrioritisationFeedback/PrioritisationFeedback';

import './styles.css';
import { ListGlass } from '../../Icons';

interface ReviewTriggerPopupProps {
  open: boolean;
  onHide: () => void;
}
const ReviewTriggerPopup = ({ open, onHide }: ReviewTriggerPopupProps) => {
  const [isFeedbackOpen, setIsFeedbackOpen] = React.useState(false);

  const onToggleFeedback = () => setIsFeedbackOpen(!isFeedbackOpen);

  return (
    <CareMapprPopup
      show={open}
      onHide={() => onHide()}
      title="Review triggers"
      titleIcon={<ListGlass />}
    >
      <div className="body-container">
        <span className="subtitle">{`{patient name + UR}`}</span>
        <div className="section">
          <p className="section-body">
            <div className="d-flex justify-content-between">
              <div className="d-flex gap-2">
                <span>Urgency:</span>
                <Chip labelText="Today" icon={<Stopwatch size={12} />} />
              </div>
              <div className="d-flex gap-2">
                <span>Effort:</span>
                <Chip
                  labelText="Medium"
                  icon={<Speedometer2 size={12} />}
                  backgroundColor={ChipBackgroundColor.YELLOW}
                  labelColor={ChipLabelColor.YELLOW}
                />
              </div>
            </div>
          </p>
          <EventTriggers />
        </div>
        <div className="prior-feeback">
          <PrioritisationFeedbackButton
            onClick={onToggleFeedback}
            isOpen={isFeedbackOpen}
          />
        </div>
      </div>
      <PrioritisationFeedback open={isFeedbackOpen} />
    </CareMapprPopup>
  );
};

export default ReviewTriggerPopup;
